import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from 'typeorm';

@Entity('bale_amt_info')
export class BaleAmtInfo {

    @PrimaryGeneratedColumn("increment", { name: 'id' })
    id: number;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @Column("int", {
        nullable: false,
        name: "bale_id"
    })
    baleId: number;

    @Column('decimal',{
        name:'bale_qty',
        nullable:false,
        precision:10,
        scale:2
    })
    baleQty : number

    @Column('decimal',{
        name:'price',
        nullable:false,
        precision:10,
        scale:3
    })
    price : number

    @Column('decimal',{
        name:'amount',
        nullable:false,
        precision:10,
        scale:3
    })
    amount : number


}